
<aside class="sidebard-bg pull-left show-mobile-menu mobile-menu-asidebar" *ngIf="isCollectionCenter">
    <div class="admin-logo pull-left mb-3 mt-3 mobile-partition">
      <img src="assets/image/admin-logo.png" class="img-fluid" />
      
      <button (click)="Mobile_sidebar_menu_btn()" class="mobile-menu-close-btn mobile-menu-btn" style="color: #fff; top: 0px; right: 15px;"><i class="far fa-times-circle" ></i></button>
    
    </div>


      
    <ul class="dashboard-asidebar">
        <!-- class="active-dashboard" -->
        <li [routerLinkActive]="['active-dashboard']"><a class="responsive-design" [routerLink]="['/sample-center-dashboard']"><i class="fas fa-tachometer-alt"></i> Dashboard</a></li>
        <li [routerLinkActive]="['active-dashboard']"><a class="responsive-design" [routerLink]="['/sample-center-appointments']"><i class="far fa-calendar-check"></i> New Appointments</a></li>
        <li [routerLinkActive]="['active-dashboard']"><a class="responsive-design" [routerLink]="['/sample-center-logged-samples']"><i class="fas fa-microscope"></i> Logged Samples</a></li>
        <li [routerLinkActive]="['active-dashboard']"><a class="responsive-design" [routerLink]="['/sample-center-results']"><i class="far fa-thumbs-up"></i> Results</a></li>

        <!-- <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/sample-center-dashboard']"><i
                    class="far fa-calendar-check"></i> Default Appointments</a></li> -->

        <!-- <li class="relative-menu">
            <a class="dropDownToggle"> <i class="far text-white fa-calendar-alt"></i> Manage Center Users <i
                    class="fas fa-angle-down" style="margin-left:5px"></i></a>
            <ul class="dropDownToggle-menu">
                <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/sample-center-users']">Users</a>
                </li>
                <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/sample-center-users-activities']">User
                        Activities</a>
                </li>
                <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/sample-center-add-user']">Add
                        User</a></li>
            </ul>
        </li> -->
        <!-- <li class="relative-menu">
            <a class="dropDownToggle2"> <i class="far text-white fa-calendar-alt"></i> Manage Sample Centers <i
                    class="fas fa-angle-down" style="margin-left:5px"></i></a>
            <ul class="dropDownToggle2-menu">
                <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/sample-centers']">Sample
                        Centers</a></li>
                <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/sample-center-employees']">Employees</a></li>
            </ul>
        </li> -->

        <li><a class="responsive-design" [routerLink]="['/sample-center-dashboard']"><i class="far fa-credit-card"></i> Payment Log</a></li>

        <li [routerLinkActive]="['active-dashboard']"><a class="responsive-design" [routerLink]="['/sample-center-calendar']"><i class="far fa-calendar-check"></i> Calender</a></li>
    </ul>
</aside>